export default ['text', 'textarea', 'code', 'json', 'number', 'email', 'radio', 'select', 'date']
